import { Asset } from '../../Asset'
import { CMSLink, CMSLinkType } from '../../CMSLink'
import { Asset as AssetType } from '@telesoft/types/payload-types'
import React from 'react'

export type RichTextUploadNodeType = {
  fields: {
    link?: CMSLinkType
    enableLink?: boolean
  }
  value?: AssetType
  relationTo: string
}

export type Props = {
  node: any
  className?: string
}

export const RichTextUpload: React.FC<Props> = props => {
  const {
    node: { fields, value },
    className,
  } = props

  let Wrap: React.ComponentType<CMSLinkType> | string = 'div'

  const styles: React.CSSProperties = {}

  let wrapProps: CMSLinkType = {}

  if (fields?.enableLink) {
    Wrap = CMSLink
    wrapProps = {
      ...fields?.link,
    }
  }

  return (
    <div style={styles} className={className}>
      <Wrap {...wrapProps}>
        <Asset resource={value as AssetType} />
      </Wrap>
    </div>
  )
}

export default RichTextUpload
